import { render, staticRenderFns } from "./AppointmentFilter.vue?vue&type=template&id=3bb2510a&"
import script from "./AppointmentFilter.vue?vue&type=script&lang=js&"
export * from "./AppointmentFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports